import React, { useState, useEffect } from 'react';
import { capitalizeWords, capitalize } from "../../../utils/capitalize/capitalizeWord";
import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";
import { ToastContainer, toast } from 'react-toastify';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/en";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { 
  updateEducation, 
  currentEducation_loading,
  currentEducation,
  dispatchEducation
} from "../../../Redux/ActionCreator";
import { useSelector, useDispatch } from "react-redux";
import LoaderModal from "../../common/LoaderModal/index.jsx";
import { SortEducation } from '../../../utils/skillsService/index.js';
dayjs.extend(customParseFormat);
dayjs.locale("en");

const EditEducation = ( { handleClick }) => {
  const dispatch = useDispatch();
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const p_profile = useSelector((e) => e.profile);
  const [fill, setFill ] = useState(null);


  const currentEdu = useSelector(state => state.currentEducation); // Redux state for current education
  const educ = useSelector(edu => edu.education);

  // **Function to Convert Formatted String Back to Dayjs**
  // const parseFormattedDate = (dateString) => {
  //   console.log("dateString", dateString);
  //   try {
  //     if (dateString) {
  //       return dayjs(dateString, "MMM YYYY", true);
  //     }
  //   } catch (error) {
  //     console.error("Error parsing date:", error);
  //   }
  //   return null;
  // };
  const parseFormattedDate = (dateString) => {
    // console.log("dateString (raw):", dateString);
    try {
      if (dateString) {
        const parts = dateString?.trim()?.split(" ");
        if (parts.length !== 2) {
          throw new Error("Invalid date format: Expected 'Month Year'");
        }
        const month =
          parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase();
        const year = parts[1];
        const normalized = `${month} ${year}`;
        // console.log("dateString (normalized):", normalized);

        // Try full month format first
        let parsed = dayjs(normalized, "MMMM YYYY", true);
        if (!parsed?.isValid()) {
          // If full month fails, try abbreviated format
          parsed = dayjs(normalized, "MMM YYYY", true);
        }

        // console.log(
        //   "Parsed result:",
        //   parsed.toString(),
        //   "isValid:",
        //   parsed.isValid()
        // );
        return parsed?.isValid() ? parsed : null;
      }
    } catch (error) {
      console.error("Error parsing date:", error);
    }
    return null;
  };


  const [ isOpen, setIsOpen ] = useState(false);
  const [ index, setIndex ] = useState(0);
  let [ prevKey, setPrevKey ] = useState(null);

  const [degree, setDegree] = useState([
    "No Formal Education",
    "Primary Education",
    "Secondary Education",
    "High School Diploma",
    "Certification",
    "Vocational/Technical Training",
    "Some College",
    "Associate Degree",
    "Bachelor's Degree",
    "Master's Degree",
    "PHD",
    "Other"
  ]);
  const [ selectedDegree, setSelectedDegree ] = useState("");
  const [ course, setCourse ] = useState("");
  const [ school, setSchool ] = useState("");
  let [ endDate, setEndDate ] = useState(dayjs());
  const [ other, setOther ] = useState("");

  const handleNoEducation = async () => {
    setSelectedDegree("No Formal Education");
    let educationData = {
      School: currentEdu.message?.School?.trim() || null,
      // Where_i_worked_location: $('[name="work_place"]').val(),
      Degree: selectedDegree?.trim() || "No Formal Education",
      Course: currentEdu.message?.Course || null,
      End_date: selectedDegree == "No Formal Education" ? null : currentEdu.message?.End_date,
    }
    dispatch(currentEducation(educationData));
    // save into server cache
    await saveIntoServerCache("current_education", educationData);
    setStep(22);
  }

  useEffect(() => {
    if (window.location.pathname.includes("/user/profile")) {
      if (p_profile.message !== null) {
        dispatch(dispatchEducation(p_profile.message?.Education));
      }
    }
  }, []);

    // Prefill fields from Redux or fetch from Redis
    useEffect(() => {
        if (currentEdu.message !== null) {
          setSelectedDegree(capitalize(currentEdu.message?.Degree?.toLowerCase()) || "");
          setOther(currentEdu.message?.other || "");
        } else {
          getOneFromServerCache("current_education")
            .then(res => res.json())
            .then(res => {
              if (res.success && res.data) {
                const eduData = JSON.parse(res.data);
                dispatch(currentEducation(eduData));
                setSelectedDegree(eduData?.Degree || "");
                setOther(eduData?.other || "");
              }
            })
            .catch(error => console.log("Error prefilling education data", error));
        }
      }, [dispatch]);

      useEffect(() => {
        if (currentEdu.message !== null) {
          let info = currentEdu.message;
          setSchool(info?.School);
          setSelectedDegree(capitalizeWords(info?.Degree?.toLowerCase()));
          setCourse(info?.Course);
          if (info?.End_date == "Present") setFill("Yes");
          let current_exp_end_date = info?.End_date == "Present" ? null : parseFormattedDate(info?.End_date);
          console.log("current_exp_end_date", current_exp_end_date);
          setEndDate(current_exp_end_date !== undefined ? current_exp_end_date: "");
        }
      }, [currentEdu.message]);

      console.log("degree", selectedDegree);

      const handleSaveCall = () => {
        if (school !== "" && course !== "") {
          if (isOpen == true) {
              let updatedData = {
                  School: school || null,
                  // Where_i_worked_location: $('[name="work_place"]').val(),
                  Degree: selectedDegree?.trim() || currentEdu.message?.Degree?.trim(),
                  Course: course || currentEdu.message?.Course || null,
                  End_date: selectedDegree == "No Formal Education" ? null : fill === "Yes"
                  ? "Present"
                  : endDate?.format("MMM YYYY"),
              }
              console.log("updatedData", updatedData);
              let newEdu = educ.education;
              newEdu[prevKey] = updatedData;
              dispatch(SortEducation(newEdu));
              if (
                p_profile.message !== null &&
                (p_profile.message?.Education == null ||
                  p_profile.message?.Education == [] ||
                  window.location.pathname.includes("/user/profile") ||
                  window.location.pathname.includes("jobs"))
              ) {
                dispatch(updateEducation(newEdu));
              }
          }
        } else {
          let allEducation = educ.education;
          let newEdu = allEducation.filter(element => element.School !== null && element.Course !== null);
          dispatch(dispatchEducation(newEdu));
        }
        
        // dispatch(dispatchActivites(educ.education));
        dispatch(currentEducation_loading());
        handleClick();
      }

    //   const updateEducation = (education, eduToUpdate) => {
    //     if (!Array.isArray(education) || education.length === 0) {
    //         console.error("education array is not valid or empty.");
    //         return;
    //     }
    
    //     if (!eduToUpdate || !eduToUpdate.Course || !eduToUpdate.School) {
    //         console.error("eduToUpdate is not valid.", eduToUpdate);
    //         return;
    //     }
    
    //     const eduToUpdateCourse = eduToUpdate.Course;
    //     const eduToUpdateSchool = eduToUpdate.School;
    
    //     console.log("Searching for:", eduToUpdateSchool, eduToUpdateCourse);
    //     console.log("education array:", education);
    
    //     const eduIndex = education.findIndex(e => 
    //         e.School?.toLowerCase() === eduToUpdateSchool?.toLowerCase() &&
    //         e.Course?.toLowerCase() === eduToUpdateCourse?.toLowerCase()
    //     );
    
    //     return eduIndex;
    // };
    
    function onDelete(key) {
      try {
        let allEducation = educ.education;
        let newEdu = allEducation.filter(element => allEducation.indexOf(element) !== key);
        dispatch(dispatchEducation(newEdu));
      } catch (error) {
        console.log(error);
      }
    }

    const handleToggle = (element, key) => {
      // if (school !== "" && selectedDegree !== "" && course !== "" && endDate !== null) {
      console.log("currentEdu.message", currentEdu.message);
      console.log("End date", endDate?.format("MMM YYYY"));
        if (isOpen == true) {
          let educationData = {
            School: school || currentEdu.message?.School?.trim() || null,
            // Where_i_worked_location: $('[name="work_place"]').val(),
            Degree:
              selectedDegree?.trim() || currentEdu.message?.Degree?.trim(),
            Course: course || currentEdu.message?.Course || null,
            End_date:
              selectedDegree == "No Formal Education"
                ? null
                : fill === "Yes"
                ? "Present"
                : endDate?.format("MMM YYYY"),
          };
            let newEdu = educ.education;
            newEdu[prevKey] = educationData;
            dispatch(dispatchEducation(newEdu));

            if (key !== index) {
              setCourse("");
              setSelectedDegree("");
              setSchool("");
              setEndDate(dayjs()); 
            } else {
              setIsOpen(false);
            }
        }
        if (key == educ.education?.indexOf(element)) {
          let eduToDispatch = educ.education[key];
          dispatch(currentEducation(eduToDispatch));
          setIsOpen(true);
          setIndex(key);
          setPrevKey(key);
          setFill("No");
        }
    }

      const handleCancel = () => {
        let allEducation = educ.education;
        let newExp = allEducation.filter(element => element?.School !== "" && element?.Course !== null);
        dispatch(dispatchEducation(newExp));
        handleClick();
      }

      const handleSchoolChange = (e) => {
        setSelectedDegree(e);
        const educationData = { Degree: e, other: other || "" };
        dispatch(currentEducation(educationData));
        saveIntoServerCache("current_education", educationData); // Save to cache
      };

      const handleAddNewEducation = (key) => {
        setSchool("");
        setSelectedDegree("");
        setCourse("");
        let educationData = {
            School: "",
            // Where_i_worked_location: $('[name="work_place"]').val(),
            Degree: "",
            Course: "",
            End_date: null,
        }
        let newEdu = educ.education || [];
        newEdu[newEdu.length] = educationData;
        dispatch(dispatchEducation(newEdu));
        setIsOpen(true);
        setIndex(key);
        setPrevKey(key);
        setFill("No");
    }
  
  return (
    <>
    <div className="bg-transparent px-4 md:px-6 lg:px-8 xl:px-10 py-8 sm:w-[100vw] vsm:w-[100vw] flex justify-center rounded-xl my-6 max-h-[90vh]">
      <div className="sm:w-[100vw] vsm:w-[100vw] gap-y-6 lg:gap-0 lg:h-full flex flex-col lg:justify-between justify-center rounded-lg p-6 md:p-8 h-full">
        {/* Main container/card */}
        <div className="w-full bg-white rounded shadow p-6">
          {/* Heading */}
          <h3 className="text-xl font-bold text-[#5843BD] my-4 text-center">Edit Education {index + 1}</h3>
          
          {educ.education !== null && educ.education?.map((element, key) => (
            <div key={key}>
            <div className="border-t border-gray-200 py-4 px-4 mb-4 bg-[#F9F4FD] rounded-lg">
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => handleToggle(element, key)}
              >
                <h3 className="text-xl font-bold text-[#5843BD] mb-4 text-center">
                  Education {key + 1}
                </h3>
                <div>
                  {isOpen == true && key === index ? 
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="32" height="32" rx="4" fill="#5843BD"/>
                    <path d="M7.95312 18.035V13.9668H15.9986H24.044V18.035H7.95312Z" fill="#E6E9F5"/>
                  </svg> :
                  <button
                    className="text-sm bg-[#5843BD] text-white rounded-lg py-2 px-6"
                  >
                    Edit
                  </button>
                  }
                </div>
              </div>            
              <h6 className="text-lg font-semibold text-black mb-4 ">
                    {element?.My_job_title}
              </h6>
              <div className="flex items-center gap-2 py-2 px-4 bg-[#FF6633] w-fit rounded-md cursor-pointer" onClick={() => onDelete(key)}>
                <span className='text-white md:text-xl vsm:text-md '>Delete</span>
                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 18C2.45 18 1.97934 17.8043 1.588 17.413C1.19667 17.0217 1.00067 16.5507 1 16V3C0.71667 3 0.479337 2.904 0.288004 2.712C0.0966702 2.52 0.000670115 2.28267 3.44827e-06 2C-0.000663218 1.71733 0.0953369 1.48 0.288004 1.288C0.48067 1.096 0.718003 1 1 1H5C5 0.716667 5.096 0.479333 5.288 0.288C5.48 0.0966668 5.71734 0.000666667 6 0H10C10.2833 0 10.521 0.0960001 10.713 0.288C10.905 0.48 11.0007 0.717333 11 1H15C15.2833 1 15.521 1.096 15.713 1.288C15.905 1.48 16.0007 1.71733 16 2C15.9993 2.28267 15.9033 2.52033 15.712 2.713C15.5207 2.90567 15.2833 3.00133 15 3V16C15 16.55 14.8043 17.021 14.413 17.413C14.0217 17.805 13.5507 18.0007 13 18H3ZM13 3H3V16H13V3ZM6 14C6.28334 14 6.521 13.904 6.713 13.712C6.905 13.52 7.00067 13.2827 7 13V6C7 5.71667 6.904 5.47933 6.712 5.288C6.52 5.09667 6.28267 5.00067 6 5C5.71734 4.99933 5.48 5.09533 5.288 5.288C5.096 5.48067 5 5.718 5 6V13C5 13.2833 5.096 13.521 5.288 13.713C5.48 13.905 5.71734 14.0007 6 14ZM10 14C10.2833 14 10.521 13.904 10.713 13.712C10.905 13.52 11.0007 13.2827 11 13V6C11 5.71667 10.904 5.47933 10.712 5.288C10.52 5.09667 10.2827 5.00067 10 5C9.71734 4.99933 9.48 5.09533 9.288 5.288C9.096 5.48067 9 5.718 9 6V13C9 13.2833 9.096 13.521 9.288 13.713C9.48 13.905 9.71734 14.0007 10 14Z" fill="white"/>
                  </svg>

              </div>
            </div>
            {isOpen && index == key && 
            <div className='bg-white'>
                <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-2 justify-center items-center my-2">
                  <div className={`flex w-full gap-y-2 vsm:my-4 md:my-0 vsm:justify-center lg:justify-start lg:w-[300px]`}>
                  <FormControl fullWidth
                        sx={{
                        // Style the outer input border:
                        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                            borderColor: "orange"
                        },
                        // When focused:
                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "orange"
                        }
                        }}
                    >
                      {/* {selectedDegree == "" ? <InputLabel>Education Level</InputLabel> : null} */}
                        <p>Education Level</p>
                        <Select
                        value={selectedDegree}
                        onChange={(e) => handleSchoolChange(e.target.value)}
                        sx={{
                            // backgroundColor: selectedDegree ? "#FF6633" : "transparent",
                            color: "black", // selectedDegree ? "white" : "black",
                            borderRadius: "10px",
                            padding: "6px 12px", // Adjust padding to match the input field
                            maxHeight: "45px", // Ensure consistent height with the input field
                            fontSize: "16px", // Adjust font size if needed
                            // Style focus state:
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#FF6633",
                            },
                            // "&.Mui-focused": {
                            //     backgroundColor: "#FF6633",
                            //     color: "white"
                            // },
                            "& .MuiSelect-icon": {
                              color: selectedDegree ? "white" : "black", // Set icon color
                            },

                        }}
                        >
                        {degree?.map((degree, idx) => (
                            <MenuItem 
                            key={idx} 
                            value={degree} 
                            sx={{
                                // Hover styles:
                                "&:hover": {
                                backgroundColor: "#FF6633",
                                color: "#fff"
                                }
                            }}
                            >
                            {degree}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                  </div>

                  <div className="flex w-full gap-y-2 vsm:justify-center">
                      <div className="lg:w-[350px] vsm:w-full flex vsm:justify-center">
                          <div className="w-full">
                              <label htmlFor="jobTitle" className="text-black font-medium text-sm mb-2">
                                  What school did you go?
                              </label>
                              <input
                              type="text"
                              id="jobTitle"
                              className="w-full border-2 lg:w-[350px] rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                              value={school}
                              onChange={(e) => setSchool(capitalizeWords(e.target.value))}
                              placeholder="School"
                              />
                          </div>
                      </div>
                  </div>

                  <div className="flex w-full gap-y-2 vsm:justify-center">
                      <div className="lg:w-[350px] vsm:w-full flex vsm:justify-center">
                          <div className="w-full">
                              <label htmlFor="jobTitle" className="text-black font-medium text-sm mb-2">
                                  Course of study?
                              </label>
                              <input
                              type="text"
                              id="jobTitle"
                              className="w-full border-2 lg:w-[350px] rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                              value={course}
                              onChange={(e) => setCourse(capitalizeWords(e.target.value))}
                              placeholder="Course"
                              />
                          </div>
                      </div>
                  </div>
              </div>

              <div className={`md:flex lg:w-full w-full flex-col lg:flex-row md:gap-8 justify-center items-center my-4`}>
                
                  <div className="flex w-full gap-y-2 vsm:my-6 md:my-0 vsm:justify-center">
                    <div className="lg:w-full vsm:w-full flex vsm:justify-center lg:justify-start">
                      <div className='w-full'>
                        <p className="text-black font-medium text-sm mb-2">
                          Are you still in school?
                        </p>
                        <div className='flex items-center w-full lg:mr-2'>
                            <div className='flex items-center justify-center py-3 px-3 border border-[#777DEA54] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent cursor-pointer mr-2 rounded-lg w-full' onClick={() => setFill("Yes")}>
                                <div className={`w-[15px] h-[15px] rounded-[50%] ${fill == "Yes" ? "bg-[#FF6633]" : "bg-white"} mr-2 border border-[#777DEA54]`}></div>
                                <p className='text-lg font-medium'>Yes</p>
                            </div>
                            <div className='flex items-center justify-center py-3 px-3 border border-[#777DEA54] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent cursor-pointer rounded-lg w-full' onClick={() => setFill("No")}>
                                <div className={`w-[15px] h-[15px] rounded-[50%] ${fill == "No" ? "bg-[#FF6633]" : "bg-white"} mr-2 border border-[#777DEA54]`}></div>
                                <p className='text-lg font-medium'>No</p>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
        
                
                  <div className="flex w-full gap-y-2 vsm:justify-center">
                    <div className="vsm:w-full lg:flex">      
                        <div className="w-full">
                          {fill == "No" && <div>
                            <label className="text-black font-medium text-sm">
                              Select graduation Date?
                            </label>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker']}>
                              <DatePicker
                                views={['month', 'year']}
                                value={endDate}
                                onChange={(newValue) => setEndDate(newValue)}
                                className="w-full"
                                // minDate={startDate}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                          </div>
                          }
                          {
                            fill == "Yes" && (
                              <p className='text-lg font-semibold text-white mb-4 py-3 bg-[#FF6633] rounded-lg px-4 vsm:my-2 my-0'>Present</p>
                            )
                          }
                          
                        </div>
                    </div>
                  </div>
                </div>
        
                
              </div> }
              {educ.education?.indexOf(element) == educ.education?.length - 1 && (
                <p className="text-[#5843BD] text-md font-semibold mb-6 cursor-pointer text-center" onClick={() => handleAddNewEducation(educ.education?.length)}>
                    <em className="underline">Click here to add new education</em>
                </p>
              )}
             </div>
          ))}

          {/* Link to add a new experience */}
          {educ.education == null || educ.education.length == 0 && (
            <p className="text-[#5843BD] text-md font-semibold mb-6 cursor-pointer text-center" onClick={() => handleAddNewEducation(0)}>
                <em className="underline">Click here to add new education</em>
            </p>
          )} 

          {/* Action buttons */}
          <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center my-2">
            <div className="flex justify-between lg:max-w-[90vw] w-full">
              <button
                  onClick={handleCancel}
                  className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 px-4 rounded-md"
              >
                  <span className="notranslate" key={flowLanguage}>
                    {flowLanguage == "Spanish" ? (
                      "Cancelar"
                    ) : (
                      "CANCEL"
                    )}
                  </span>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="24" height="24" rx="12" fill="#FF6633"/>
                      <path d="M15.1893 18C15.1132 18 15.0412 17.9653 14.9938 17.9058L12.0561 14.2175C11.953 14.0881 11.7548 14.0927 11.6579 14.2269L9.00599 17.8964C8.95899 17.9615 8.88362 18 8.80337 18H6.07388C5.86606 18 5.74897 17.7612 5.87625 17.5969L10.132 12.1039C10.2027 12.0127 10.2017 11.8849 10.1297 11.7948L5.82441 6.40605C5.69361 6.24233 5.81018 6 6.01973 6H8.81098C8.88693 6 8.95877 6.03453 9.00621 6.09384L11.9435 9.76586C12.0469 9.89503 12.2449 9.89004 12.3416 9.75583L14.9727 6.10386C15.0197 6.03865 15.0952 6 15.1756 6H17.9053C18.1131 6 18.2302 6.23864 18.1031 6.40295L13.8676 11.8792C13.7971 11.9703 13.798 12.0978 13.8698 12.1879L18.1767 17.5942C18.3072 17.758 18.1906 18 17.9812 18H15.1893Z" fill="white"/>
                  </svg>

              </button>
              <button
                  onClick={handleSaveCall}
                  className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 px-4 rounded-md"
              >
                <span className="notranslate" key={flowLanguage}>
                  {flowLanguage == "Spanish" ? (
                    "GUARDAR"
                  ) : (
                    "SAVE"
                  )}
                </span>
                  <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
    </>
  );
};

export default EditEducation;
